export const site = {
  name: '瓜田黑料',
  englishName: 'Guatian Archive',
  tagline: '深挖起势 · 理清脉络 · 吃瓜不迷路',
  description:
    '瓜田黑料是一个专注娱乐热点时间线复盘与舆论观察的内容站，把公开物料按时间排好，帮你在信息爆炸的热点里快速吃透整个脉络。',
  email: 'contact@guatianheili.com',
  submitEmail: 'tips@guatianheili.com',
  heroImage:
    'https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20illustration%20of%20a%20vast%20melon%20field%20at%20sunset%20with%20geometric%20rows%20and%20glowing%20network%20nodes%20above%2C%20warm%20amber%20orange%20and%20deep%20green%20tones%2C%20flat%20minimal%20magazine%20cover%20aesthetic%2C%20generous%20dark%20negative%20space&width=1600&height=900&seq=guatian-hero-00&orientation=landscape',
  heroAlt: '暖橙色黄昏下的抽象瓜田插画，作为瓜田黑料首页首屏背景',
};

export const navLinks = [
  { label: '首页', to: '/' },
  { label: '全部专题', to: '/topics' },
  { label: '关于我们', to: '/about' },
  { label: '联系我们', to: '/contact' },
];

export const stats = [
  { value: '1,280+', label: '已复盘热点' },
  { value: '36', label: '深度时间线' },
  { value: '18万', label: '月阅读人次' },
  { value: '5', label: '内容方向' },
];

export const principles = [
  {
    icon: 'ri-time-line',
    title: '先排时间，再下判断',
    desc: '任何一条动态都放回它原本的时间位置，先看清顺序，再讨论对错。',
  },
  {
    icon: 'ri-link-m',
    title: '只引用公开可查',
    desc: '素材以公开报道与当事人自行发布的内容为主，来源会尽量标注清楚。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '区分事实与观点',
    desc: '待核实的信息明确标注，不把推测写成结论，不把情绪当成证据。',
  },
  {
    icon: 'ri-refresh-line',
    title: '留下修正空间',
    desc: '热点会反转，文章会更新。我们保留修订记录，允许自己在证据变化后改口。',
  },
];

export const testimonials = [
  {
    name: '晚风有信',
    role: '从 2024 年开始追更',
    text: '以前看热点全凭感觉，现在会先来这里看时间线。很多反转其实早就有迹可循，只是当时没人排过顺序。',
  },
  {
    name: '陈皮乌龙',
    role: '媒体从业者',
    text: '公关话术那几篇很实用，措辞和时机的拆解比很多行业课讲得都清楚，做工作汇报时直接参考过。',
  },
  {
    name: '第七个瓜',
    role: '普通读者',
    text: '最喜欢"理性吃瓜"这个栏目。核对清单真的能救命，现在转发前会先停三十秒。',
  },
  {
    name: '山与海之间',
    role: '从专题列表页来的',
    text: '分类做得很清楚，想看行业生态就点行业生态，不用在一堆标题里翻，阅读体验很干净。',
  },
];

export const brandTimeline = [
  { year: '2023', text: '从个人博客开始，把每周追的热点整理成一条条时间线。' },
  { year: '2024', text: '内容扩展到公关话术、代言合同与传播机制分析。' },
  { year: '2025', text: '上线分类专题与搜索，读者可以按方向快速找到需要的复盘。' },
  { year: '2026', text: '加入"理性吃瓜"方法论栏目，把核对清单沉淀成可复用的工具。' },
];